import cn from 'classnames';
import * as React from 'react';

import { ICardProps } from '../../Card/Card';
import { Card } from '../../index';

import styles from './PersonCard.module.scss';

interface IProps extends ICardProps {
  className?: string;
}

const PersonCard = ({ className, label, top, middle, bottom, ...props }: IProps) => {
  return (
    <Card
      {...props}
      inline
      className={cn(styles.container, className)}
      label={label}
      top={<div className={styles.top}>{top}</div>}
      middle={<div className={styles.middle}>{middle}</div>}
      bottom={<div className={styles.bottom}>{bottom}</div>}
    />
  );
};

export default PersonCard;
